var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "resolutionLostInfo" },
    [
      _c("TextLink", {
        staticClass: "lostUserId",
        attrs: {
          "link-url": _vm.lostUserIdUrl,
          "link-text": _vm.lostUserIdText,
          "target-value": "_blank",
        },
      }),
      _vm._v(" "),
      _c("TextLink", {
        staticClass: "lostPassword",
        attrs: {
          "link-url": _vm.lostPasswordUrl,
          "link-text": _vm.lostPasswordText,
          "target-value": "_blank",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }